import { inject, Injectable } from '@angular/core';
import { STUDY_X_OF_Y_SECONDARY_VALUES_KPIS, STUDY_X_SECONDARY_VALUE_KPIS } from '@catalogues';
import { Kpi, KpiKeys, KpiTypes } from '@models';

import { CommonFunctionsService } from '../common-functions/common-functions.service';

@Injectable({
  providedIn: 'root'
})
export class KpiCommonFunctionsService {
  private commonFunctionsService: CommonFunctionsService = inject(CommonFunctionsService);
  getKpiDisplayValue(kpi: Kpi, kpiKey: KpiKeys): string | number | undefined {
    if (kpi.value === undefined) return;

    switch (kpi.type) {
      case 'percent':
        return this.commonFunctionsService.roundValue(kpi.value * 100, 1);
      case 'days':
        return this.commonFunctionsService.formatNumberWithCommas(Math.trunc(kpi.value));
      case 'number':
        switch (kpiKey) {
          case 'deviation_rate_per_subject':
            return this.commonFunctionsService.roundValue(kpi.value, 2);
          case 'critical_or_major_quality_events':
            return this.commonFunctionsService.formatNumberWithCommas(kpi.value) + ' critical';
          default:
            return this.commonFunctionsService.formatNumberWithCommas(kpi.value);
        }
      default:
        return kpi.value;
    }
  }

  getKpiDisplayUnit(kpiType: KpiTypes): '%' | '' {
    return kpiType === 'percent' ? '%' : '';
  }

  getKpiDisplaySecondaryValue(kpi: Kpi, kpiKey: KpiKeys): string | undefined {
    const { numerator, denominator } = kpi;
    if (STUDY_X_SECONDARY_VALUE_KPIS.includes(kpiKey)) {
      if (numerator != null) {
        return kpiKey === 'critical_or_major_quality_events'
          ? `${this.commonFunctionsService.formatNumberWithCommas(numerator)} major`
          : this.commonFunctionsService.formatNumberWithCommas(numerator);
      }
    }
    if (numerator == null || denominator == null) return;
    if (numerator === undefined || denominator === undefined) return;

    if (STUDY_X_OF_Y_SECONDARY_VALUES_KPIS.includes(kpiKey)) {
      const defaultFormat = (val: number): string | number =>
        this.commonFunctionsService.formatNumberWithCommas(
          this.commonFunctionsService.roundValue(val, 1)
        );
      let format: (val: number) => string | number = defaultFormat;

      // Formats number as 1M / 100k etc, only used for past certain limits
      const fmt = new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 1
      });

      format = (val: number) => {
        if (val >= 10000) {
          return fmt.format(val);
        }

        return defaultFormat(val);
      };

      return `${format(numerator)} of ${format(denominator)}`;
    }

    return;
  }
}
